angular.module('zc.zenclerkS')
  .component('zcsDeemedInvoice', {
    templateUrl: '/templates/zenclerk_s/sites/invoices/show/zcs_deemed_invoice.html',
    controllerAs: 'vm',
    bindings: {
      invoice: '=',
      currency: '='
    },
    controller() {

    },
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/invoices/show/zcs_deemed_invoice.directive.js